import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(website)/page.jsx");
